import { Box, Divider, Stack, Text } from '@mantine/core'
import React from 'react'
import ReportItem from '../ReportItem'

interface FailureComplyCaseProps {
  number: number
  item: any
}

const formatPartyType = (partyType: string): string => {
  switch (partyType) {
    case '1':
      return '自然人'
    case '2':
      return '法人'
    case '3':
      return '其他组织'
    default:
      return partyType || '-'
  }
}

const formatSign = (sign: string): string => {
  switch (sign) {
    case '0':
      return '正常'
    case '1':
      return '下架'
    default:
      return sign || '-'
  }
}

const formatSignalRating = (rating: string): string => {
  switch (rating) {
    case '1':
      return '低'
    case '2':
      return '中'
    case '3':
      return '高'
    default:
      return rating || '-'
  }
}

export default function FailureComplyCase({ number, item }: FailureComplyCaseProps) {
  const cardBackgroundColor = '#ffffff'

  return (
    <Box
      style={{
        backgroundColor: cardBackgroundColor,
        padding: 'var(--mantine-spacing-xs)',
        borderRadius: 'var(--mantine-radius-sm)',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '1px solid rgba(0,0,0,0.05)',
        marginBottom: 'var(--mantine-spacing-xs)',
      }}
    >
      <Stack gap={'xs'} className={'text-gray-500'}>
        <Text size={'sm'} c={'dark'} fw={500}>
          案件（{number}）
        </Text>

        {/* 基本信息 */}
        <ReportItem name={'案号'} value={item?.caseCode} />
        <ReportItem name={'执行法院'} value={item?.courtName} />
        <ReportItem name={'失信被执行人姓名'} value={item?.executorName} />

        {/* 时间信息 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'立案时间'} value={item?.caseRegTime} />
        <ReportItem name={'发布时间'} value={item?.casePublishTime} />

        {/* 个人信息 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'地域名称'} value={item?.areaName} />
        <ReportItem name={'性别'} value={item?.sexName} />
        <ReportItem name={'年龄'} value={item?.age} />
        <ReportItem name={'主体类型'} value={formatPartyType(item?.partyTypeName)} />

        {/* 企业信息 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'企业法人姓名'} value={item?.businessEntity} />

        {/* 执行信息 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'执行依据文号'} value={item?.gistcid} />

        {/* 状态和信号 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'数据类型'} value={item?.dataType} />
        <ReportItem name={'下架标识'} value={formatSign(item?.sign)} />
        <ReportItem name={'信号描述'} value={item?.signalDesc} />
        <ReportItem name={'信号等级'} value={formatSignalRating(item?.signalRating)} />
      </Stack>
    </Box>
  )
}
